export { ModuleRegistry, parseModuleValue } from './registry';
export { moduleRegistry } from './registry';
export type { IModule, ModuleContent, ModuleParams, FontConfig } from './types';
export { defaultFontConfig } from './types';

import { IModule } from './types';
import { moduleRegistry } from './registry';

import './draw'; // Ensure PageGen prototype extensions are loaded
import { textModule } from './text';
import { dotModule } from './dot';
import { latexModule } from './latex';
import { imageModule } from './image';
import { tableModule } from './table';
import { clockModule } from './clock';
import { chartModule } from './chart';
import { mindmapModule } from './mindmap';
import { smartModule } from './smart';
import { fractionModule } from './fraction';
import { uiModule } from './ui';
import { diffModule } from './diff';

let initialized = false;
const registeredModules: IModule[] = [
  textModule,
  dotModule,
  latexModule,
  imageModule,
  tableModule,
  clockModule,
  chartModule,
  mindmapModule,
  smartModule,
  fractionModule,
  uiModule,
  diffModule,
];

export function registerModule(module: IModule): void {
  registeredModules.push(module);
}

export function initializeModules(): void {
  if (initialized) return;

  for (const mod of registeredModules) {
    try {
      moduleRegistry.register(mod);
    } catch (e) {
      console.warn(`Failed to register module ${(mod).name}:`, e);
    }
  }

  initialized = true;
}

export function isInitialized(): boolean {
  return initialized;
}
